import { use, useState } from "react";
import {
  useField as useFormikField,
  useFormikContext,
  FieldInputProps,
  FieldMetaProps,
  FieldHelperProps,
  FormikContextType,
  FormikContext,
} from "formik";
import { getError, formatEvent } from "./selectors";

export const useField = <TValue>({
  name,
}: {
  name?: string;
}): [
  Partial<FieldInputProps<TValue>>,
  Partial<FieldMetaProps<TValue> & { error: string | undefined }>,
  Partial<FieldHelperProps<TValue>>,
] => {
  const context = use(FormikContext);
  const [isFormikInput] = useState(!!context);
  const [persistedName] = useState(name);
  let field: FieldInputProps<TValue>;
  let meta: FieldMetaProps<TValue>;
  let helpers: FieldHelperProps<TValue>;
  let status: FormikContextType<any>;

  if (isFormikInput && persistedName) {
    // eslint-disable-next-line
    [field, meta, helpers] = useFormikField({ name: persistedName });
    // eslint-disable-next-line
    status = useFormikContext().status;
  } else {
    return [{}, {}, {}];
  }

  const onChange = (changedValue: any): void => {
    setTimeout(() => field.onChange(formatEvent(changedValue, field.name)), 0);
  };

  const error = getError(field.name, {
    touched: meta.touched,
    error: meta.error,
    status,
  });

  return [{ ...field, onChange }, { ...meta, error }, helpers];
};
